import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BehaviourSerService {
  public islocationChangedTime: BehaviorSubject<string> = new BehaviorSubject('0');
  constructor() {

    // setTimeout(() => {
    //   this.islocationChangedTime.next(new Date() + '');
    // }, 100);

  }
}
